module.exports = __webpack_public_path__ + "static/media/20170806_37day_1859AT.a0f7ef00.jpg";